const APP_ROUTES = {
    HOME: "/",
    GETSTARTED: "/getstarted",
    SERVICES: "/services",
    CONTACT: "/contact",
    PRIVACYPOLICY: "/privacy-policy",
    TERMSOFUSE: "/terms-of-use",
    ROUGHQUESTIONS: "/rough-questions",
    
      };
      
      export { APP_ROUTES };